import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, List } from '@material-ui/core';

import { useQuery } from 'react-admin';
import {
  frequencyReference,
  multiLineStringToArray,
  sortTableOfObjects,
} from '../../../../helpers';
import { NestedSimpleListItem } from '../../../../components';

export const buildMissions = (data) => {
  const missions = {};

  data.forEach((item) => {
    const descriptions = multiLineStringToArray(item.description);

    if (!item.espace || !descriptions) {
      return;
    }
    const espaces = item.espace.split(';');

    espaces.forEach((espace) => {
      let richEspace;
      if (!item.product) {
        richEspace = `Autre - ${espace}`;
      } else {
        richEspace = `${item.product} - ${espace}`;
      }

      if (!missions[richEspace]) {
        missions[richEspace] = {
          name: richEspace,
          des: {},
        };
      }

      const freq = frequencyReference[item.frequency];

      if (!missions[richEspace].des[freq]) {
        missions[richEspace].des[freq] = [];
      }

      missions[richEspace].des[freq].push(...descriptions);
    });
  });

  const tableMissions = [];

  Object.keys(missions).forEach((mission) => {
    tableMissions.push(missions[mission]);
  });

  tableMissions.sort(sortTableOfObjects('name'));
  return tableMissions;
};

const ListPrestations = ({ record, resource }) => {
  const query =
    resource === 'contract'
      ? {
          type: 'getManyReference',
          resource: 'prestation',
          payload: {
            target: 'contract_id',
            id: record.id,
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'id', order: 'DESC' },
          },
        }
      : {
          type: 'getManyReference',
          resource: 'prestation',
          payload: {
            target: 'account_id',
            id: record.account_id,
            filter: { contract_active: true },
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'id', order: 'DESC' },
          },
        };

  const { data: allActivesCahierDesCharges, loading } = useQuery(query);

  const missions = buildMissions(allActivesCahierDesCharges ?? []);

  if (!allActivesCahierDesCharges || loading) {
    return <CircularProgress size={25} thickness={2} />;
  }

  return (
    <List>
      {missions.map((espace) => {
        return (
          <NestedSimpleListItem
            key={espace.name}
            text={espace.name}
            variant="primary"
            dense
            defaultOpen
          >
            {Object.keys(espace.des).map((key) => {
              return (
                <NestedSimpleListItem key={key} text={key} dense>
                  {espace.des[key].map((item) => {
                    return (
                      <NestedSimpleListItem
                        key={item}
                        text={item}
                        variant="light"
                        dense
                      />
                    );
                  })}
                </NestedSimpleListItem>
              );
            })}
          </NestedSimpleListItem>
        );
      })}
    </List>
  );
};

ListPrestations.propTypes = {
  data: PropTypes.object,
  resource: PropTypes.string,
};

ListPrestations.defaultProps = {
  data: {},
  resource: '',
};

export default ListPrestations;
